let dynamicUrl = window.location.origin


let CommonBaseURl, ScreenerUrl, TokenAPI, TPScreenerUrl, EMagazineUrl

if (dynamicUrl == 'https://icai.capitaline.com') {
    CommonBaseURl = 'https://icai.capitaline.com/icaiapi/api/General/'
    ScreenerUrl = 'https://icai.capitaline.com/icaiapi/api/Screener/'
    TPScreenerUrl = 'https://icai.capitaline.com/icaiapi/api/TPScreener/'
    EMagazineUrl = 'https://icai.capitaline.com/icaiapi/api/EMagazine/'
    // token API 
    TokenAPI = 'https://icai.capitaline.com/icaiapi/token'

} else {
    //     CommonBaseURl = 'http://icai.capitaline.com/icaiapi/api/General/'
    // ScreenerUrl = 'http://icai.capitaline.com/icaiapi/api/Screener/'
    // TPScreenerUrl = 'http://icai.capitaline.com/icaiapi/api/TPScreener/'
    // EMagazineUrl = 'http://icai.capitaline.com/icaiapi/api/EMagazine/'
    // // token API 
    // TokenAPI = 'http://icai.capitaline.com/icaiapi/token'
    // CommonBaseURl = 'http://192.168.50.110:886/API/api/General/'
    // ScreenerUrl = 'http://192.168.50.110:886/API/api/Screener/'
    // TPScreenerUrl = 'http://192.168.50.110:886/API/api/General/TPScreener/'
    // EMagazineUrl = 'http://192.168.50.110:886/API/api/EMagazine/'
    // // token API 
    // TokenAPI = 'http://192.168.50.110:886/API/token'

    CommonBaseURl = 'http://localhost:32155/api/General/'
    ScreenerUrl = 'http://localhost:32155/api/Screener/'
    TPScreenerUrl = 'http://localhost:32155/api/General/TPScreener/'
    EMagazineUrl = 'http://localhost:32155/api/EMagazine/'
    // token API 
    TokenAPI = 'http://localhost:32155/token'
}

export { CommonBaseURl, TokenAPI, ScreenerUrl, TPScreenerUrl, EMagazineUrl }
